import React from 'react'
import OffHeader from './offHeader'

export default function OffLayout({ children }: any) {
  return (
    <div className='' >
      <OffHeader />
      {children}
    </div>
  )
}
